import { Checkbox, FormControlLabel, FormHelperText } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

export const ControlledCheckbox = ({
  name,
  defaultValue = false,
  label,
  helperText,
  ...rest
}) => {
  const { control, formState } = useFormContext()

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value, ref } }) => (
          <FormControlLabel
            control={
              <Checkbox
                color='primary'
                checked={value}
                onChange={onChange}
                variant='standard'
                name={name}
                inputRef={ref}
                {...rest}
              />
            }
            label={label}
          />
        )}
      />
      {helperText !== undefined && formState.errors[name] === undefined && (
        <FormHelperText id={`helper-text-${name}`}>{helperText}</FormHelperText>
      )}
      {formState.errors[name]?.message !== undefined && (
        <FormHelperText
          id={`error-helper-text-${name}`}
          error
          style={{ textAlign: 'right', paddingRight: 8 }}
        >
          {formState.errors[name]?.message}
        </FormHelperText>
      )}
    </>
  )
}
